import React from 'react';
import { FlatCardData, ParkingCardData, BusinessCardData } from '../../CardsComponents/types';
import styles from './CardPageAdditionalInfo.module.css';
import cn from 'classnames';

type PropertyData = FlatCardData | ParkingCardData | BusinessCardData;

interface CardPageAdditionalInfoProps {
  property: PropertyData;
}

const CardPageAdditionalInfo: React.FC<CardPageAdditionalInfoProps> = ({ property }) => {
  const isFlat = (property: PropertyData): property is FlatCardData => property.type === 'flat';
  const isCar = (property: PropertyData): property is ParkingCardData =>
    property.type === 'parking';
  const isBusiness = (property: PropertyData): property is BusinessCardData =>
    property.type === 'business';

  const renderFlatInfo = (flat: FlatCardData) => (
    <>
      <div className={styles.info_row}>
        <span className={cn('text_body_b2', styles.info_label)}>Жилая площадь</span>
        <span className={cn('text_subheaders_sh2', styles.info_value)}>
          от {flat.livingArea} м²
        </span>
      </div>
      <div className={styles.info_row}>
        <span className={cn('text_body_b2', styles.info_label)}>Этаж</span>
        <span className={cn('text_subheaders_sh2', styles.info_value)}>
          {flat.floor} из {flat.totalFloors}
        </span>
      </div>
      <div className={styles.info_row}>
        <span className={cn('text_body_b2', styles.info_label)}>Подъезд</span>
        <span className={cn('text_subheaders_sh2', styles.info_value)}>
          {flat.entrance} из {flat.totalEntrances}
        </span>
      </div>
      <div className={styles.info_row}>
        <span className={cn('text_body_b2', styles.info_label)}>Высота потолков</span>
        <span className={cn('text_subheaders_sh2', styles.info_value)}>{flat.cellingHeight} метра</span>
      </div>
      <div className={styles.info_row}>
        <span className={cn('text_body_b2', styles.info_label)}>Заселение</span>
        <span className={cn('text_subheaders_sh2', styles.info_value)}>{flat.checkIn}</span>
      </div>
      <div className={styles.info_row}>
        <span className={cn('text_body_b2', styles.info_label)}>Тип дома</span>
        <span className={cn('text_subheaders_sh2', styles.info_value)}>{flat.projectType}</span>
      </div>
    </>
  );

  const renderCarInfo = (parking: ParkingCardData) => (
    <>
      <div className={styles.info_row}>
        <span className={cn('text_body_b2', styles.info_label)}>Этаж</span>
        <span className={cn('text_subheaders_sh2', styles.info_value)}>{parking.floor === 0 ? 'Цоколь' : `${parking.floor} из ${parking.totalFloors}`}</span>
      </div>
      <div className={styles.info_row}>
        <span className={cn('text_body_b2', styles.info_label)}>Номер</span>
        <span className={cn('text_subheaders_sh2', styles.info_value)}>{parking.numberPlace} из {parking.totalNumberPlaces}</span>
      </div>
      <div className={styles.info_row}>
        <span className={cn('text_body_b2', styles.info_label)}>Передача</span>
        <span className={cn('text_subheaders_sh2', styles.info_value)}>{parking.checkIn}</span>
      </div>
    </>
  );

  const renderBusinessInfo = (business: BusinessCardData) => (
    <>
      <div className={styles.info_row}>
        <span className={cn('text_body_b2', styles.info_label)}>Этаж</span>
        <span className={cn('text_subheaders_sh2', styles.info_value)}>{business.floor === 0 ? 'Цоколь' : `${business.floor} из ${business.totalFloors}`}</span>
      </div>
      <div className={styles.info_row}>
        <span className={cn('text_body_b2', styles.info_label)}>Номер</span>
        <span className={cn('text_subheaders_sh2', styles.info_value)}>{business.numberPlace} из {business.totalNumberPlaces}</span>
      </div>
      <div className={styles.info_row}>
        <span className={cn('text_body_b2', styles.info_label)}>Высота потолков</span>
        <span className={cn('text_subheaders_sh2', styles.info_value)}>{business.cellingHeight} метра</span>
      </div>
      <div className={styles.info_row}>
        <span className={cn('text_body_b2', styles.info_label)}>Передача</span>
        <span className={cn('text_subheaders_sh2', styles.info_value)}>{business.checkIn}</span>
      </div>
      <div className={styles.info_row}>
        <span className={cn('text_body_b2', styles.info_label)}>Тип дома</span>
        <span className={cn('text_subheaders_sh2', styles.info_value)}>{business.projectType}</span>
      </div>
    </>
  );

  return (
    <div className={styles.project_wrapper}>
      <div className={styles.block_title}>
        <h3>О проекте</h3>
      </div>
      <div className={styles.project_info}>
        {isFlat(property) && renderFlatInfo(property)}
        {isCar(property) && renderCarInfo(property)}
        {isBusiness(property) && renderBusinessInfo(property)}
      </div>
    </div>
  );
};

export default CardPageAdditionalInfo;
